export enum Continent {
  None = 'None',
  Africa = 'Africa',
  Antarctica = 'Antarctica',
  Asia = 'Asia',
  Europe = 'Europe',
  NorthAmerica = 'NorthAmerica',
  SouthAmerica = 'SouthAmerica',
  Oceania = 'Oceania',
}

export const ContinentDescriptor = Object.freeze({
  [Continent.None]: 'None',
  [Continent.Africa]: 'Africa',
  [Continent.Antarctica]: 'Antarctica',
  [Continent.Asia]: 'Asia',
  [Continent.Europe]: 'Europe',
  [Continent.NorthAmerica]: 'North America',
  [Continent.SouthAmerica]: 'South America',
  [Continent.Oceania]: 'Oceania (Australia & Islands)',
});
